import React, { useState, useEffect} from "react";
import {  useNavigate, Navigate } from "react-router";

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// import Swiper core and required modules
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';        
// IMPORTANTE: Asegúrate de tener estas dos líneas
import 'swiper/css';
import 'swiper/css/pagination';
//import { Navigate } from "react-router-dom";



import CourseCompleteIcon from "./common/template/icons/CourseComplete"

import Template from "./common/template/Template";
import FlashMessage from "./common/FlashMessage";

import AlertBox from "./common/template/AlertBox";
import RocketMap from "./common/visuals/RocketMap";

import UserService from "../services/user.service";
import AuthService from "../services/auth.service";
import ComicHeroSection from './common/sections/ComicHeroSection';

//import RenderPuntosForm from "./Puntos"


import { useAuth } from "../context/AuthContext";





export default function MyCourses () {

  const navigate = useNavigate();
  //const user = AuthService.getCurrentUser();

    const { user } = useAuth();


  const backUrl = process.env.REACT_APP_BACK_URL
              
  
  //const [taskId, setTaskId] = useState(false);
  
  const [showModal, setShowModal] = useState(false);
  const [flashMessage, setFlashMessage] = useState(localStorage.getItem('cmx_flashMessage'));


  const [message, setMessage] = useState(false);

  const [error, setError] = useState(false);

  const wrapperClass = `w-full h-auto p-4 mb-4 mt-12  mx-auto border border-slate-600  rounded-lg md:rounded-b-none  shadow-md bg-white overflow-hidden `;

  // ... dentro de tu componente principal o donde renderizas la fila:

  
  function CoursesComponent({uId}){   
    
    const [loading, setLoading] = useState(false);
    const [content, setContent] = useState(false);
    const [puntos,setPuntos] = useState(false);
    const [cursoId,setCursoId] = useState(false);  
    

   
    useEffect(() => {
      // Add scroll event listener when the component mounts
      
      if(!user){
                    
        navigate('/login');
      }
    
      let ignore = false;

      function createOptions() {
        return {
          uId: user.uId,           
          oId: user.org_id,
          catId: 0         
        };
      }
      
      const options = createOptions();
      
      if(!options.uId){
        setContent("");
        setError("no se recibieron los parametros correctos.")
        //setMessage("no se recibieron los parametros correctos.")
        
      } else {

          UserService.getCourses(options.uId,options.oId,options.catId,user).then(

              (response) => {

                if(!ignore){
                  setContent(response?.data)
                  
                  setPuntos(parseFloat(response.data.puntos_b?.puntos_acum))
                  //setListContentPending(response?.data?.tasks_pending);
                  //setListContentComplete(response?.data?.tasks_complete);
                  console.log(response?.data)
                  //console.log(response?.data?.tasks_pending)
                  //console.log(response);              
                  //console.log(response?.status);
                  //console.log(response?.statusText)

                  if(response.data?.message){
                    
                    //setMessage(response?.data.message)
                  }
                  console.log(response.data?.message)

                }
              
              },

              (error) => {
                const _content =
                  (error?.response && error?.response.data) ||
                  error?.message ||
                  error?.toString();
                  console.log(_content);
                setError(_content);

                if(_content.indexOf('401') !== -1){
                    localStorage.removeItem("user");
                    //localStorage.removeItem("cs_uxsurvey_session");
                    window.location.reload()
                }
              
              }
            
          )

        
      }  

 
      return () => {

        ignore = true;
        

      };
  
    }, [uId]);

   const StartButton = ({className, labelClassName, disabled, children}) => {

             
      return (   
  
        <button  type="submit" id="submit"
                className={
                  `
                 ${className}
                 
                 
                  transition-all ease-in-out hover:scale-110 delay-50 duration-200
                  `                    
                } 
                disabled={disabled} >
          
          <span className={` ${labelClassName}  `}>{children}</span>
          
          
          
  
        </button>
  
      );
    
    }

    function RenderList({content}){

      // ... dentro de tu componente principal:
      const [cursoExpandido, setCursoExpandido] = useState(null);

      const handleCardClick = (cursoId) => {
        // Si haces clic en la que ya está abierta, se cierra. Si no, se abre la nueva.
        console.log('clicked a card '+cursoId);
        setCursoExpandido(cursoExpandido === cursoId ? null : cursoId);
      };

      function handleSubmit(event) {

          event.preventDefault();
          setLoading(true);

          const safariWindow = window.open('about:blank', '_blank');

          const form = event.target;
          setCursoId(form.id);
          const formData = new FormData(form);
          //formData.append('image', selectedFile);
          const values = [...formData.entries()];
          const formElements = form.elements;

          //const onSubmitObs = formData.get("obs");
          //const onSubmitCheck = formData.get("is_complete");

          //const onSubmitPhoto = formData.get("image");
        
            
          UserService.setCursoStart(user, form.id )
            .then(
              (response) => {
              
                  console.log(response);              
                  
                  
                  
                  console.log(response.data?.message)

                  setMessage(response.data?.message);
                  
                  
                  if(response.status === 204){
                    setError(error + response.statusText) 
                    setFlashMessage({
                      message : response.statusText,
                      type : 'error'
                     })                
                  
                  } else {
                     setFlashMessage(JSON.stringify({
                      message : response.data?.message,
                      type : 'success'
                  }))  
                  }

                  // 2. Extrae el link de la respuesta (asumiendo que viene como data.url)
                  //const courseId = response.data?.curso.id; 
                  const otp = response.data?.otp; 
                  const urlDestino = `${backUrl}index.php/course/${form.id}/${otp}`; 

                  if (otp && safariWindow && urlDestino) {
                    // 3. Abre el link en una pestaña nueva de forma segura
                    //window.open(`${backUrl}index.php/course/${form.id}/${otp}`, '_blank', 'noopener,noreferrer');
                    safariWindow.location.href = urlDestino;

                  } else {
                    console.error('Error: No se cuenta con un enlace válido');
                    setError('Error: No se cuenta con un enlace válido - ' + response.statusText)
                    setFlashMessage({
                      message : 'Error: No se cuenta con un enlace válido - ' + response.statusText,
                      type : 'error'
                    })
                    if (safariWindow) {
                        safariWindow.close();
                    }
                  }
                  

              })
              .catch( 
                (error) => {
                  const resMessage =
                    (error.response &&
                      error.response.data &&
                      error.response.data.message) ||
                    error.message || error.statusText ||
                    error.toString();
                  //setMessage(resMessage);
                  let errorMsg = 'No se pudo procesar la operacion: ';
                  setError(errorMsg + resMessage)
                  setFlashMessage({
                      message : 'Error iniciando curso - ' + resMessage,
                      type : 'error'
                     })
                  console.log(resMessage);
                }
              ).finally( ()=>{

                  setCursoId(null)
                  setLoading(false)

                }                
                
              );
                
      
      } 
          
      return(
          <div className=" w-full h-[45vh] sm:h-[60vh] m-0 overflow-y-scroll">
                
            <div id="cursos-display" 
              className="w-full mx-auto  p-3 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 place-content-start ">
                             
            
              
              {content.cursos.map(row => {

                const isExpanded = cursoExpandido === row.curso_id;

                return (
                  
                  <div 
                    // El div principal ya no maneja el click directamente para evitar conflictos de profundidad
                    className={`flex flex-col group relative transition-all duration-300 rounded-3xl ring-1  w-full overflow-hidden justify-between shadow-xl
                      ${isExpanded 
                        ? 'row-span-2 h-auto p-2 ring-green-500 ' 
                        : 'h-32 sm:h-34 ring-neutral-300 hover:ring-neutral-200 '
                      }`} 
                    key={`div-curso-${row.curso_name}`}
                  >
                    
                    
                      
                    {/* 1. CAPA INVISIBLE PARA CLICS DE FONDO (Imagen y Overlay) */}
                    <div 
                      id="clicking-surface"
                      className="absolute inset-0 z-20 cursor-pointer"
                      onClick={() => handleCardClick(row.curso_id)}
                    />

                    {/* 2. FORMULARIO CON EVENTO DE EXPANSIÓN (Al hacer clic en textos o zonas vacías) */}
                    <form 
                      id={row.curso_id} 
                      onSubmit={handleSubmit} 
                      onClick={() => handleCardClick(row.curso_id)} 
                      className="z-30 w-full cursor-pointer"
                    >
                      <div className={` w-full mx-auto p-1 rounded-xl transition-colors  ${isExpanded ? 'bg-white/70 overflow-y-auto max-h-[40vh] ' : ' group-hover:bg-white/10'}`}>
                        <div className={`w-full inline-flex ${isExpanded ? '':''}`}>
                          <h2 className={`w-full text-pretty m-1 font-bold transition-all ${isExpanded ? 'text-xs md:text-base text-neutral-700' : 'text-base md:text-xl text-white'}`}>
                            { row.curso_title }&nbsp; 
                            <span className={` font-extralight   ${isExpanded ? 'text-neutral-700':'text-white'}`}>{ `[${row.curso_name}]` }</span>
                          </h2>
                          
                              
                          {!parseInt(row.user_curso_is_complete)  ?
                            (
                              ''
                            ):(
                              <CourseCompleteIcon className={`w-6 h-6 rounded-full justify-center bg-white   ${parseInt(row.user_curso_is_complete) ? 'fill-green-500 ' : 'fill-neutral-300 opacity-50' }  `} 
                                    iconClassName={` w-6 h-6  `} />

                            )

                          }  
                        </div>
                         
                        
                          
                            
                          
                        
                        
                        <div className={`flex flex-col opacity-100 transition-all duration-200 ${isExpanded ? 'block' : 'hidden'}`}>
                          <p className="font-extralight text-[11px] text-neutral-900 m-0">
                            { row.curso_description }
                          </p>
                        
                          <div className="flex flex-row w-full justify-between m-0 items-center">
                            <div className="w-1/2">
                              {/* DETENEMOS PROPAGACIÓN SOLO EN EL ENLACE 
                              <a href={`${row.link_prospect ? row.link_prospect : row.prospect ? row.prospect : '#' }`}
                                onClick={(e) => e.stopPropagation()} 
                                className="hover:no-underline underline text-[10px] font-base m-0 p-1 w-fit text-neutral-700 hover:text-neutral-900"
                                target="_blank" rel="noreferrer noopener">
                                Ver Prospecto
                              </a>
                              */}
                            </div>
                            <div className="my-2">
                              {
                                parseInt(row.user_curso_is_complete) ? (
                                  <p className="font-extralight text-[9px] italic text-neutral-600">Completado {row.user_curso_date_completed}</p>
                                ) :(
                                    <StartButton 
                                  className={
                                    `
                                      w-fit h-fit m-0 p-0 z-30 rounded-lg ring-1 ring-neutral-100 hover:ring-white bg-gradient-to-b  hover:shadow-md
                                      from-green-400 to-green-800
                                       

                                    `
                                  }
                                  labelClassName="m-0 p-1 text-[11px] font-bold text-white text-center"
                                       
                                  onClick={(e) => e.stopPropagation()} 
                                >
                                {parseInt(row.user_curso_is_initiated) ? ('Continuar') : ('Iniciar')}                               
                                
                              
                              </StartButton> 
                                )
                              }
                              
                            </div>
                          </div>
                          {row.user_curso_is_initiated && !row.user_curso_is_complete ? (
                            <p className="font-extralight text-[9px] italic text-neutral-600">Iniciado el {row.user_curso_date_created}</p>
                          ) : (
                            <p className="font-extralight text-[9px] italic text-neutral-600">No Iniciado. Completar cursos te permite acumular puntos.</p>
                          )}
                        </div>
                      </div>
                    </form>



                    {/* Capas de diseño de fondo */}
                    <div id="overlay" className={`z-10 absolute inset-0 bg-neutral-800 transition-opacity duration-300 ${isExpanded ? 'opacity-0' : 'bg-opacity-35'}`}></div>
                    
                    <img src={`${backUrl}assets/images/${row.curso_img}`} 
                      alt="imagen del curso" 
                      className={`z-0 absolute inset-0 object-cover object-center transition-all duration-300
                        ${isExpanded 
                          ? '-inset-x-32 rounded-full w-64 h-64 opacity-20 m-auto' 
                          : 'w-full h-full opacity-100'
                        }`}
                    />
                  </div>
                  
                  
                  
                );
              })}
               
            
            
          </div>

        </div>  
      );
          
    }

    //en este return  los swipers 👇👇👇
  
    return (
              
      <div className="flex flex-col relative z-0 ">
                        
              {loading && (
                <div className="flex">
                  <svg className="animate-spin h-4 w-4 fill-slate-600" viewBox="0 0 24 24">
                    <path opacity="0.2" fillRule="evenodd" clipRule="evenodd" d="M12 19C15.866 19 19 15.866 19 12C19 8.13401 15.866 5 12 5C8.13401 5 5 8.13401 5 12C5 15.866 8.13401 19 12 19ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" />
                    <path d="M2 12C2 6.47715 6.47715 2 12 2V5C8.13401 5 5 8.13401 5 12H2Z" />
                  </svg>
                  <span className="text-slate-700 font-extralight ml-2">Loading...</span>
                </div>

              )}
              {content && (   
                <div className="w-[75vw]  mx-auto overflow-hidden block place-content-start">
                  <Swiper
                                      modules={[Navigation, Pagination, Scrollbar, A11y]}
                                      spaceBetween={50}
                                      slidesPerView={1}
                                      loop={true} 
                                      pagination={{ type: 'bullets', clickable: true }}
                                      onSlideChange={() => console.log('slide change')}
                                      onSwiper={(swiper) => console.log(swiper)}
                                      >
                    
                    <SwiperSlide>
                      <div className="w-full h-screen ">
                        <h3 className="text-base md:text-lg  text-slate-600  m-0">Cursos disponibles </h3>
                        <p className="font-light text-[10px] text-neutral-700 m-0 ">Estos son los cursos disponibles para su usuario:</p>
                        <RenderList content={content}/>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="w-full">
                        <ComicHeroSection/>
                        <p className="text-xs font-normal">Completa cursos para mejorar tus habilidades, acumula puntos por cada curso que completes, alcanza los hitos y gana fabulosos premios!</p>
                        <h3 className="text-base md:text-lg m-0 text-slate-600">Mis puntos acumulados</h3>
                        <h4 className="text-xs md:text-base  ">Usted ha acumulado :&nbsp;<span className="font-semibold text-[13px]">{`${puntos} ` ? puntos : 0} </span>&nbsp;puntos.</h4>
                        <RocketMap puntos={puntos ? puntos : 0}/>
                        

                        
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="w-full h-screen">
                          <h3 className="text-base md:text-lg  text-slate-600  m-0">Reconocimientos y certificaciones </h3>
                          <h4 className="text-xs md:text-base m-0">Últimos reconocimientos recibidos :&nbsp;<span className="font-light text-[10px]">No se han encontrado reconocimientos</span>.</h4>
                          <hr/>
                          <h4 className="text-xs md:text-base m-0">Ultimas certificaciones obtenidas : &nbsp;<span className="font-light text-[10px]">No se han encontrado certificaciones</span>.</h4>

                      </div>

                    </SwiperSlide>
                         
                  </Swiper>
                 
                  <hr/>
                  <div id="good-idea" className="w-full  flex flex-row  m-0 p-2 rounded-xl bg-cyan-400 bg-opacity-15 text-cyan ">
                          <span className="text-3xl">💡</span>
                          <span className="text-[11px] md:text-xs text-cyan-700 font-light">Para acumular puntos complete cursos. Si no aparecen cursos, pida a su administrador que se afilie a más cursos;</span>
                  </div> 
                </div>
              )}
            
                           
      </div>
 
    );
  
  }


   
 
  
  return (
    
    <Template>
        <div 
        className={`      `+wrapperClass}>
        
      
        <div className={`flex flex-col 
                    
                    ${showModal && (
                      `hidden`
                    )
                    }
                    
        `} >
          
          <h1 className="text-zinc-600 text-2xl md:text-3xl lg:text-4xl m-0">My Courses</h1>

              {flashMessage && (
                  
                  <FlashMessage flashMessage={flashMessage} setFlashMessage={setFlashMessage}  />
                 
              )
              
              }
             
            
                {user &&


                  <CoursesComponent uId={user.uId} />


                }
                {!user &&
                  <>
                    <Navigate to="/login" replace={true} state={{ from: "/mycourses" }} />
                    
                  </>
                }
                               
        
        </div>   
        
        {/*Id &&(

          <div className="fixed flex top-0 left-0 m-0 w-screen h-screen ">
            
         
            <div id="overlay" className="absolute z-30 top-0 left-0 w-full h-[100vh]  bg-slate-600 bg-opacity-80"></div>
            <TaskView taskId={taskId}/>

          </div>


        )*/}

        
            
        </div>
      </Template>
  );

  
};


